import React, { PureComponent } from "react"
import { map, isEqual } from 'lodash-es'
import { formPagePath } from '../utilities/route'
import NavBar from "./navigation/nav-bar"
import NavStatistics from './navigation/nav-statistics'
import { Link } from "react-router-dom"
import "antd/lib/tree-select/style/css"
import StatisticsPageHero from './ui/statistics-page-hero'
import SortingWidget from './ui/sorting-widget'
import ImportanceHearts from './ui/importance-hearts'
import StatementStatBarWithDistribution from './ui/statement-stat-bar-with-distribution'
import ThemeBadge from './ui/theme-badge'
import NavMainAftergameLinks from './navigation/nav-main-aftergame-links'
import Button from './ui/button'
import styled from 'styled-components'
import CompactStatRow from './ui/compact-stat-row'
import ViewToggler from './ui/view-toggler'
import { TABLET, LAPTOP, DESKTOP } from '../utilities/breakpoints'
import ParameterFilter from './ui/parameter-filter'
import { YOU_FILTER } from '../utilities/helpers'
import { sortingService } from '../utilities/sortingService'
import { Survey } from '../utilities/Survey'
import { mergeWithStatistics, likertResponseToPercentage } from '../utilities/statistics'
import RespondentGroups from './ui/respondent-groups'

class StatisticsPageStatements extends PureComponent {

  constructor(props) {
    super(props);
    const _surveyBeingEdited = sessionStorage.getItem("surveyBeingEdited") || false;
    this.state = {
      surveyBeingEdited: !!(_surveyBeingEdited && _surveyBeingEdited === "true")
    };
  }

  t = (phrase) => {
    const { useTranslate } = this.props;

    return useTranslate(`data_vault.${phrase}`)
  }

  handleFiltersChange = value => {
    this.props.onSetFilters(value);
  }

  handleViewModeChange = viewMode => {
    this.props.onSetStatementsViewMode(viewMode);
  }

  renderQuestionStat = (questionStats, index) => {
    const {
      result,
      rate,
      skipped,
      participants,
      title,
      respondentGroups
    } = questionStats;

    const {
      match: {
        params: { surveyId }
      },
      questionnaire: {
        isAfterGameGuest,
        canViewAfterGame
      },
      useTranslate,
      filters
    } = this.props

    const showDistribution = (canViewAfterGame || isAfterGameGuest) && !isEqual(filters, YOU_FILTER);

    return (
      <div
        key={index}
        className="d-flex bg-white finish-page__stats--details finish-page__stats--details--with-padding flex-column bs pt-3 pb-3 mb-3"
      >
        <div className="w-100">
          <div className="question driver driver--details mt-3 mb-4">
            <div className="theme-badges">
              <ThemeBadge themeTitle={questionStats.themeTitle} themeIndex={questionStats.surveyThemeIndex} />
            </div>
            <div className="statement-stat-header-row">
              <span className="statement__title">{title}</span>
              <div className="importance-rating d-flex align-items-center">
                <label className="mb-0 mr-2">
                  {this.t("importance")}:{" "}
                </label>
                <ImportanceHearts importance={rate} />
                <span className="ml-2">{(rate && rate !== 0) ? rate.toFixed(1) : ''}</span>
              </div>
            </div>
            <StatementStatBarWithDistribution
              showDistribution={showDistribution}
              surveyId={surveyId}
              filters={filters}
              questionId={questionStats.id}
              result={result}
              useTranslate={useTranslate}
            />
            {(canViewAfterGame || isAfterGameGuest) && 
              <div className="d-flex align-items-center statement-details-row">
                {(skipped > 0) &&
                  <div className="statement-dncm-amount">
                    {useTranslate("data_vault.does_not_concern")}:  <span>{skipped}/{participants}</span>
                  </div>
                }
                {respondentGroups && <RespondentGroups items={respondentGroups} useTranslate={useTranslate} />}
              </div>
            }
          </div>
        </div>
      </div>
    );
  };

  render() {
    const {
      match: {
        params: { surveyId, languageCode },
      },
      surveyStatistics,
      respondentParameters,
      questionnaire,
      questionnaire: {
        canViewAfterGame,
        isAfterGameGuest,
        isFinished,
        canAnswer,
        logo,
        isDialogueActive,
        areProgressReportsActive
      },
      useTranslate,
      sortingType,
      sortAscending,
      statementsViewMode,
      filters,
      improvementProject
    } = this.props;

    const toStatistics = formPagePath(languageCode, surveyId, 'finish', 'themes')
    const toEditAnswers = formPagePath(languageCode, surveyId)

    const title = (!canViewAfterGame && !isAfterGameGuest)
      ? useTranslate("survey_finished.your_statistics_page_title")
      : useTranslate("data_vault.statistics_page_title");

    const startEditingSurvey = () => {
      sessionStorage.setItem("surveyBeingEdited", "true");
      this.setState({surveyBeingEdited: true});
    }

    const isAfterGame = (canViewAfterGame || isAfterGameGuest)
    const notEnoughRespondents = surveyStatistics.__typename === 'NotEnoughRespondentsError'
    let sortedStatements
    if (!notEnoughRespondents) {
      const survey = new Survey(questionnaire.catalysts, respondentParameters)
      const sortingFunction = sortingService.getSortingFunction(sortingType);
      sortedStatements = mergeWithStatistics(survey.getLikertQuestions(), surveyStatistics.questions).map(question => {
        const theme = survey.getTheme(survey.getThemeIdByLikertQuestionId(question.id))
        return {
          id: question.id,
          title: question.title,
          result: likertResponseToPercentage(question.statistics.aggregatedResponse),
          rate: question.statistics.aggregatedImportance,
          skipped: question.statistics.skippedRespondentCount,
          participants: question.statistics.totalRespondentCount,
          themeTitle: theme.title,
          surveyThemeIndex: survey.getSurveyThemeIndex(theme.id),
          respondentGroups: isAfterGame ? survey.getRespondentGroups(question.id, 'likert') : undefined
        }
      })
      .sort(sortingFunction(sortAscending ? sortAscending : false));
    }

    return (
      <section className="finish-page">
        <StatisticsPageHero>
          <div className="aftergame-page-container">
            <NavBar
              to={isFinished && !canViewAfterGame && toStatistics}
              afterGame
              inverse={true}
              logo={logo}
              canViewAfterGame={canViewAfterGame}
              isAfterGameGuest={isAfterGameGuest}
            >
              {(canViewAfterGame || isAfterGameGuest) &&
                <NavMainAftergameLinks
                  activePage={"statistics"}
                  languageCode={languageCode}
                  surveyId={surveyId}
                  useTranslate={useTranslate}
                  isDialogueActive={isDialogueActive}
                  showProgressReports={areProgressReportsActive}
                  improvementProject={improvementProject}
                />
              }
            </NavBar>
          </div>
          <div className="aftergame-page-container">
            <div className="finish-page__intro">
              <h1>{title}</h1>
              { (!canViewAfterGame && !isAfterGameGuest) ?
                <div className="stats-description">
                  <p>{useTranslate("survey_finished.your_statistics_page_description")}</p>
                  { (isFinished && !canViewAfterGame && canAnswer) &&
                    <div>
                      <Button
                        as={Link}
                        to={toEditAnswers}
                        onClick={() => startEditingSurvey()}
                        size={"md"}
                      >
                        {this.t("edit_answers_button")}
                      </Button>
                    </div>
                  }
                </div>
                :
                <div className="stats-description">
                  <p>{useTranslate("data_vault.statistics_page_description")}</p>
                </div>
              }

              <div className="finish-page__intro__nav-holder">
                <NavStatistics
                  activePage={"statements"}
                  languageCode={languageCode}
                  surveyId={surveyId}
                  useTranslate={useTranslate}
                  questionnaire={questionnaire}
                />
              </div>
            </div>
          </div>
        </StatisticsPageHero>
        <div className="aftergame-page-container statistics-page-content finish-page__stats pb-5">
          <div className="finish-page__filters">
            {((canViewAfterGame || isAfterGameGuest) && respondentParameters.length > 0) && (
              <ParameterFilter
                filters={filters}
                handleFiltersChange={this.handleFiltersChange}
                respondentParameters={respondentParameters}
                isAfterGameGuest={isAfterGameGuest}
                useTranslate={useTranslate}
              />
            )}
            <ViewToggler
              viewMode={statementsViewMode}
              handleVMChange={this.handleViewModeChange}
              useTranslate={useTranslate}
            />
            <SortingWidget useTranslate={useTranslate} />
          </div>
          {!notEnoughRespondents && sortedStatements.length > 0 ?
            (statementsViewMode === "compact" ?
                <CompactListContainer>
                  {map(sortedStatements, (statement, index) => (
                    <CompactStatRow
                      key={index}
                      index={index}
                      surveyThemeIndex={statement.surveyThemeIndex}
                      result={statement.result}
                      rate={statement.rate}
                      title={statement.title}
                      useTranslate={useTranslate}
                      showLabels={index === 0}
                      showNumbers={false}
                    />
                  ))}
                </CompactListContainer>
              :
                map(sortedStatements, this.renderQuestionStat)
            )
            :
            <p>{useTranslate("data_vault.no_results_for_parameter")}</p>
          }
        </div>
      </section>
    );
  }
}

export default StatisticsPageStatements;

const CompactListContainer = styled.div`
  background-color: #fff;
  border-radius: 10px;
  padding: 20px 10px;
  
  @media${TABLET} {
    padding: 30px 20px 20px;
  }
  
  @media${LAPTOP} {
    padding: 40px 30px 30px;
  }
  @media${DESKTOP} {
    padding: 40px 40px 30px;
  }
`;



// WEBPACK FOOTER //
// ./src/components/statistics-page-statements.js